/**
 * EmptyState — "Empty states teach" (UX principle 10).
 *
 * Pattern: 24px Lucide icon at top, title, one-sentence body explaining what
 * goes here and how to add the first one, optional primary action button.
 */
import type { ReactNode } from 'react';
import { cn } from '@/lib/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  body?: ReactNode;
  action?: ReactNode;
  className?: string;
}

export function EmptyState({ icon, title, body, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn('flex flex-col items-center justify-center gap-3 py-12 text-center', className)}
    >
      {icon ? <div className="text-tertiary">{icon}</div> : null}
      <div>
        <h4 className="text-base font-semibold text-primary">{title}</h4>
        {body ? <p className="mt-1 max-w-md text-sm text-secondary">{body}</p> : null}
      </div>
      {action ? <div>{action}</div> : null}
    </div>
  );
}
